import {
  getErrorBasedOnCode,
  BOLETO_CANCEL_ERRORS_ENUM
} from '@/enums/boleto-cancel-errors.enum'
import { isPreconditionFailed } from '@/enums/http-status.enum'

class BoletoCancelErrorManager {
  constructor (error) {
    this.error = error
  }

  isPasswordIncorrectError () {
    return isPreconditionFailed(this.error.status)
  }

  getBoletoCancelErrorBasedOnResponse () {
    try {
      const FIRST = 0
      const error = Object.keys(this.error?.body)?.[FIRST]
      return getErrorBasedOnCode(error)
    } catch (err) {
      return BOLETO_CANCEL_ERRORS_ENUM.GENERIC
    }
  }
}

export default BoletoCancelErrorManager
